module.exports = __webpack_public_path__ + "img/chengf.e82bf48d.png";